export const translations = {
    ru: {
        'nav.home': 'Главная',
        'nav.checkout': 'Страница оплаты',
        'app.header.prefix': 'Премиум и суперлайки в приложении',
        'app.header.suffix': 'на iOS и Андроид',
        'app.enterAccountId.title': 'Введите ID аккаунта приложения',
        'app.enterAccountId.subtitle.part1': 'Чтобы получить ID своего аккаунта: откройте настройки приложения → О приложении → Системная информация → ID аккаунта или ',
        'app.enterAccountId.subtitle.linkText': 'нажмите сюда',
        'app.emptyUserIdError': 'Введите айди своего аккаунта',
        'app.selectPlan': 'Выберите покупку',
        'app.selectPaymentMethod': 'Выберите метод оплаты',
        'app.submit': 'Перейти к оплате',
        'app.wrongUserIdDescription': 'Айди, который вы ввели, не существует. Попробуйте ввести его еще раз, чтобы мы знали куда начислить покупку.',
        'app.alert.paymentLinkFailed': 'При попытке создать ссылку на оплату что-то сломалось: {status} ({details})',
        'app.alert.generic': 'Что-то пошло не так',
        'premium.week.title': 'Премиум на неделю',
        'premium.month.title': 'Премиум на месяц',
        'premium.year.title': 'Премиум на год',
        'superlike.one_superlike_v1.title': '1 суперлайк',
        'superlike.five_superlikes_v1.title': '5 суперлайков',
        'payment.methods.card.title': 'Карты РФ (Visa, MasterCard, МИР)',
        'payment.methods.stripe.title': 'Зарубежные карты (Visa, MasterCard, AmEx, etc)',
        'payment.methods.stars.title': 'Telegram Stars',
        'payment.methods.stars.extra': 'Можно купить через банковские карты РФ',
        'payment.methods.crypto.title': 'Криптовалюты',
        'payment.methods.antilopay.title': 'СБП (Сбер, Т-банк, ВТБ и другие)',
        'validation.searching': 'Ищем ID...',
        'validation.invalid': 'Неверный ID',
        'validation.valid': 'Верный ID',
        'support.contactPrefix': 'Если у вас есть любые вопросы, обратитесь в техподдержку ',
        'support.contactMiddle': ' или в техподдержку приложения через ',
        'support.anonchatLinkLabel': 'anon.chat',
        'support.telegramLinkLabel': 'чат в Телеграме',
        'actions.goHome': 'Вернуться на главную страницу',
        'success.title': 'Вы оформили премиум-подписку',
        'success.subtitle': 'Подписка будет выдана автоматически на ваш аккаунт в приложении в течение 5-15 минут',
        'success.superlike.title': 'Спасибо за покупку суперлайков',
        'success.superlike.subtitle': 'После подтверждения оплаты суперлайки появятся на балансе вашего аккаунта в приложении',
        'successStripe.cancel.prefix': 'Чтобы отменить подписку, перейдите по ',
        'successStripe.cancel.link': 'этой',
        'successStripe.cancel.middle': ' ссылке или свяжитесь с ',
        'successStripe.cancel.support': 'поддержкой',
        'successStripe.cancel.suffix': '.',
        'fail.title': 'Не удалось оформить премиум-подписку',
        'fail.superlike.title': 'Не удалось оплатить суперлайки',
        'fail.subtitle': 'Что-то пошло не так. Попробуйте еще раз или свяжитесь с нами',
    },
    en: {
        'nav.home': 'Home',
        'nav.checkout': 'Checkout',
        'app.header.prefix': 'Premium and superlikes for',
        'app.header.suffix': 'on iOS and Android',
        'app.enterAccountId.title': 'Enter your app account ID',
        'app.enterAccountId.subtitle.part1': 'To find your account ID: open app settings → About → System info → Account ID or ',
        'app.enterAccountId.subtitle.linkText': 'tap here',
        'app.emptyUserIdError': 'Enter your account ID',
        'app.selectPlan': 'Choose a purchase',
        'app.selectPaymentMethod': 'Choose a payment method',
        'app.submit': 'Proceed to payment',
        'app.wrongUserIdDescription': 'The ID you entered does not exist. Please enter it again so we can apply your purchase to the right account.',
        'app.alert.paymentLinkFailed': 'We failed to create a payment link: {status} ({details})',
        'app.alert.generic': 'Something went wrong',
        'premium.week.title': 'Weekly Premium',
        'premium.month.title': 'Monthly Premium',
        'premium.year.title': 'Yearly Premium',
        'superlike.one_superlike_v1.title': '1 superlike',
        'superlike.five_superlikes_v1.title': '5 superlikes',
        'payment.methods.card.title': 'Russian cards (MIR)',
        'payment.methods.stripe.title': 'Visa, MasterCard, AmEx, etc',
        'payment.methods.stars.title': 'Telegram Stars',
        'payment.methods.stars.extra': '',
        'payment.methods.crypto.title': 'Cryptocurrencies',
        'payment.methods.antilopay.title': 'SBP Payment',
        'validation.searching': 'Looking up the ID...',
        'validation.invalid': 'Account ID not found',
        'validation.valid': 'Valid account ID',
        'support.contactPrefix': 'If you have any questions, contact ',
        'support.contactMiddle': ' or reach the app team via ',
        'support.anonchatLinkLabel': 'anon.chat support',
        'support.telegramLinkLabel': 'the Telegram chat',
        'actions.goHome': 'Back to the main page',
        'success.title': 'Your premium subscription is active',
        'success.subtitle': 'The subscription will be applied to your in-app account automatically within 5-15 minutes',
        'success.superlike.title': 'Thank you for purchasing superlikes',
        'success.superlike.subtitle': 'Once your payment is confirmed, the superlikes will be added to your in-app account balance',
        'successStripe.cancel.prefix': 'To cancel the subscription, go to ',
        'successStripe.cancel.link': 'this',
        'successStripe.cancel.middle': ' link or contact ',
        'successStripe.cancel.support': 'support',
        'successStripe.cancel.suffix': '.',
        'fail.title': "We couldn't activate the premium subscription",
        'fail.superlike.title': "We couldn't complete your superlike payment",
        'fail.subtitle': 'Something went wrong. Try again or contact us',
    },
};

